import axiosBase from 'axios'

const endpoint = process.env['REACT_APP_END_POINT']

const axiosInstance = axiosBase.create({
  baseURL: endpoint,
})

export { axiosInstance }
